import { theme as defaultTheme } from 'cdk-radial';
import { RadialTheme } from 'drive-ui-packages';

export const theme: RadialTheme = {
  ...defaultTheme,
  zIndex: {
    ...defaultTheme.zIndex,
    tableRowFocused: {
      ...defaultTheme.zIndex.tableRowFocused,
      value: '4'
    }
  }
};
